import { useSyncExternalStore } from "react";

let open = false;
const listeners = new Set<() => void>();

/** Whether the iOS software keyboard is up (DUE-417). Written only by
 * `initIosApp` from `@capacitor/keyboard`'s `keyboardWillShow/Hide`; on web
 * and Telegram nothing writes it, so it stays `false`. */
export function setKeyboardOpen(next: boolean): void {
  if (open === next) return;
  open = next;
  listeners.forEach((l) => l());
}

export function subscribeKeyboardOpen(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getKeyboardOpen(): boolean {
  return open;
}

export function useKeyboardOpen(): boolean {
  return useSyncExternalStore(subscribeKeyboardOpen, getKeyboardOpen, () => false);
}
